import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormGroup, FormLabel, Grid, IconButton, ListItemText, MenuItem, TextField, Tooltip, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { RecencyReportFilter, Report, ReportFilterTargetFields, TimeUnits } from "../../api/dtos";

interface IRecencyReportFilterSelectProps {
    report?: Report,
    applicableFields: ReportFilterTargetFields[],
    requestRecencyFilters?: RecencyReportFilter[],
    recencyReportFilters?: RecencyReportFilter[],
    setRecencyReportFilters: React.Dispatch<React.SetStateAction<RecencyReportFilter[] | undefined>>,
}

const RecencyReportFilterSelect:FC<IRecencyReportFilterSelectProps> = ({
    applicableFields,
    requestRecencyFilters,
    setRecencyReportFilters
}) => {
    const theme = useTheme();

    const [amount, setAmount] = useState<number | undefined>();
    const [unit, setUnit] = useState<TimeUnits | undefined>();

    useEffect(() => {

        const index =  requestRecencyFilters?.findIndex(filter => 
            filter.filterTargetField && 
            applicableFields.includes(filter.filterTargetField)
        )

        if(
            requestRecencyFilters && 
            index !== undefined &&
            index !== -1
        ) {
            setAmount(requestRecencyFilters[index].quantity);
            setUnit(requestRecencyFilters[index].unit);
        }
        else {
            setAmount(undefined);
            setUnit(undefined);
        }
    }, [requestRecencyFilters]);

    const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if(Number.isNaN(Number(event.target.value))) {
            return;
        }    

        if(event.target.value === "") {
            setAmount(undefined);
        }
        else {
            setAmount(Number(event.target.value))
        }
        
        if(event.target.value && unit) {
            const filters = applicableFields.map(field => new RecencyReportFilter({
                filterTargetField: field,
                quantity: Number(event.target.value),
                unit: unit
            }))

            setRecencyReportFilters(filters);
        }
        else {
            setRecencyReportFilters(_old => []);
        }
    }
    const handleUnitChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setUnit(event.target.value as unknown as TimeUnits);

        if(event.target.value && amount) {
            const filters = applicableFields.map(field => new RecencyReportFilter({
                filterTargetField: field,
                quantity: amount,
                unit: event.target.value as unknown as TimeUnits
            }))

            setRecencyReportFilters(filters);
        }
        else {
            setRecencyReportFilters(_old => []);
        }
    }
    return (
        <>
            <FormGroup>
                <FormLabel 
                    component={"legend"}
                    sx={{
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    Over the last
                    <Tooltip 
                        title="Leave blank for current financial year"
                    >
                        <IconButton 
                            size="small"
                            sx={{
                                color: theme.palette.secondary.light
                            }}
                        >
                            <FontAwesomeIcon icon={faCircleQuestion} />
                        </IconButton>
                    </Tooltip>
                </FormLabel>
                <Grid
                    container
                    gap={2}
                    sx={{
                        mt: 1
                    }}
                >
                    <TextField
                        inputMode="numeric"
                        onChange={handleAmountChange}
                        label={"Quantity"}
                        value={amount ?? ""}
                    />
                    <TextField
                        select
                        onChange={handleUnitChange}
                        label={"Unit"}
                        value={unit ?? ""}
                        slotProps={{
                            input: {
                                sx: {
                                    height: 56
                                }
                            }
                        }}
                        sx={{
                            width: 100
                        }}
                    >
                        <MenuItem id={""} value={""}><ListItemText primary={" "} /></MenuItem>
                        <MenuItem id={TimeUnits.Days.toString()} value={TimeUnits.Days}><ListItemText primary={"Days"}/></MenuItem>
                        <MenuItem id={TimeUnits.Weeks.toString()} value={TimeUnits.Weeks}><ListItemText primary={"Weeks"}/></MenuItem>
                        <MenuItem id={TimeUnits.Months.toString()} value={TimeUnits.Months}><ListItemText primary={"Months"}/></MenuItem>
                        <MenuItem id={TimeUnits.Years.toString()} value={TimeUnits.Years}><ListItemText primary={"Years"}/></MenuItem>
                    </TextField>
                </Grid>
            </FormGroup>
        </>
    );
}

export default RecencyReportFilterSelect;